import { render, staticRenderFns } from "./cc-loading.vue?vue&type=template&id=06046e98&scoped=true"
import script from "./cc-loading.vue?vue&type=script&lang=js"
export * from "./cc-loading.vue?vue&type=script&lang=js"
import style0 from "./cc-loading.vue?vue&type=style&index=0&id=06046e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06046e98",
  null
  
)

export default component.exports